'use strict';
import videoChatTemplate from './ngTemplates/video-chat.html';


export const commentsStates = {
  videoChat: 'video-chat',
};

routerConfig.$inject = [
  '$stateProvider',
];

export function routerConfig(
  $stateProvider,
) {
  $stateProvider
    .state(commentsStates.videoChat, {
      title: 'video.chat.title',
      url: '/video-chat/:channelId/:sessionId',
      template: videoChatTemplate,
      controller: 'VideoChatController as videoChat',
      resolve: {
        ready: [
          'AuthService',
          'AppBootstrapper',
          (AuthService, AppBootstrapper) =>
            AuthService.initAuthComplete()
              .then(() => AppBootstrapper.loaded()),
        ],
      },
    });
}



// WEBPACK FOOTER //
// ./src/js/comments/router.js